export const curriculumList = [
  {
    id: 1,
    level: 'Level 1',
    title: '기초반',
    subtitle: 'Foundation Course',
    duration: '주 2회 · 2시간 · 4주 (총 16시간)',
    weeks: '1~4주차',
    badge: '입문',
    image: 'https://public.readdy.ai/ai/img_res/826331e34d136824c311509606019251.jpg',
    curriculum: [
      '색소학 기초 및 피부 구조 이론',
      '위생 관리 및 안전 수칙 교육',
      '기초 드로잉 및 디자인 원리',
      '실습 도구 사용법 및 기본 기법',
    ],
    benefits: ['이론 + 실습 병행 교육', '소수 정예 1:1 지도', '위생교육 이수증 발급'],
    desc: '처음 시작하는 분들을 위한 입문 과정입니다. 색소학, 피부 이론, 위생 관리 등 전문가로서의 기초를 탄탄히 다집니다.',
  },
  {
    id: 2,
    level: 'Level 2',
    title: '심화반',
    subtitle: 'Advanced Course',
    duration: '주 2회 · 2시간 · 4주 (총 16시간)',
    weeks: '5~8주차',
    badge: '심화',
    image: 'https://readdy.ai/api/search-image?query=professional%20beauty%20student%20practicing%20advanced%20semi-permanent%20makeup%20on%20a%20model%20in%20a%20sleek%20modern%20studio%2C%20instructor%20observing%20closely%2C%20precision%20needle%20work%20on%20eyebrow%20area%2C%20bright%20studio%20lighting%2C%20focused%20and%20skilled%20atmosphere%2C%20no%20text%20no%20signage&width=600&height=380&seq=curriculum_level2_class_v2&orientation=landscape',
    curriculum: [
      '눈썹 반영구 실전 기법 심화',
      '아이라인 & 입술 반영구 실습',
      '색상 배합 및 수정 기법',
      '실제 모델 실습 (지도 하)',
    ],
    benefits: ['실제 모델 실습 진행', '개인별 피드백 제공', '포트폴리오 사진 촬영 지원'],
    desc: '기초를 바탕으로 실전 기술을 집중 훈련하는 과정입니다. 실제 모델 실습을 통해 현장 감각을 키웁니다.',
  },
  {
    id: 3,
    level: 'Level 3',
    title: '마스터반',
    subtitle: 'Master Course',
    duration: '주 2회 · 2시간 · 4주 (총 16시간)',
    weeks: '9~12주차',
    badge: '수료',
    image: 'https://readdy.ai/api/search-image?query=confident%20skilled%20beauty%20artist%20independently%20performing%20masterclass%20semi-permanent%20makeup%20tattoo%20on%20client%20in%20a%20premium%20professional%20studio%2C%20polished%20elegant%20interior%20with%20warm%20lighting%2C%20high-end%20beauty%20salon%20atmosphere%2C%20expert%20level%20work%2C%20no%20text%20no%20signage&width=600&height=380&seq=curriculum_level3_master_v2&orientation=landscape',
    curriculum: [
      '고급 기법 및 트렌드 스타일 실습',
      '독립 모델 실습 (자율 진행)',
      '포트폴리오 완성 및 피드백',
      '자격증 시험 대비 최종 점검',
    ],
    benefits: ['본회 공식 자격증 응시 자격 부여', '창업 컨설팅 1:1 지원', '수료증 및 경력증명서 발급'],
    desc: '전 과정의 완성 단계로, 독립적인 실습과 포트폴리오 완성을 통해 현장 투입 가능한 전문가로 거듭납니다.',
  },
];

export const benefits = [
  {
    icon: 'ri-award-line',
    title: '본회 공식 자격증 발급',
    desc: '보건복지부 정식 인가 단체인 대한문신사중앙회에서 발급하는 공식 자격증을 취득할 수 있습니다.',
  },
  {
    icon: 'ri-store-line',
    title: '창업 컨설팅 지원',
    desc: '수료 후 개인 스튜디오 창업을 원하는 수강생에게 1:1 창업 컨설팅과 인테리어, 마케팅 노하우를 제공합니다.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '위생교육 이수 지원',
    desc: '문신사 필수 위생교육을 지부에서 직접 이수할 수 있으며, 이수증 발급까지 원스톱으로 지원합니다.',
  },
  {
    icon: 'ri-team-line',
    title: '수강생 네트워크',
    desc: '전국 대한문신사중앙회 회원 네트워크를 통해 동료 아티스트들과 교류하고 최신 트렌드를 공유할 수 있습니다.',
  },
  {
    icon: 'ri-briefcase-line',
    title: '취업 & 스튜디오 연계',
    desc: '우수 수료생에게는 협력 뷰티샵 및 반영구 문신 스튜디오 취업을 연계해 드립니다.',
  },
  {
    icon: 'ri-refresh-line',
    title: '보수 교육 무료 제공',
    desc: '수료 후에도 신기술 및 트렌드 업데이트 보수 교육을 무료로 제공하여 지속적인 성장을 지원합니다.',
  },
];
